import React from 'react';
import { FormControl, InputLabel, Select as MuiSelect, MenuItem } from '@mui/material';
import { acmeTextFieldSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

/**
 * Labeled select field with acme styling.
 */
export default function Select({
  label,
  labelId,
  value,
  onChange,
  children,
  displayEmpty,
  renderValue,
  required,
  fullWidth = true,
  size = 'small',
  sx,
  formControlSx,
  ...props
}) {
  const id = labelId || (label ? `select-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      size={size}
      sx={mergeSx(acmeTextFieldSx, formControlSx)}
    >
      {label && <InputLabel id={id}>{label}</InputLabel>}
      <MuiSelect
        labelId={id}
        label={label}
        value={value}
        onChange={onChange}
        displayEmpty={displayEmpty}
        renderValue={renderValue}
        sx={mergeSx(sx)}
        {...props}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
}

Select.Item = MenuItem;
